<template>
  <!-- v-show="$parent.hideScrollbar" -->
  <div class="expand-icon" @click="$emit('click')">
    <span class="more-container">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="32"
        height="8"
        viewBox="0 0 32 8"
        class="expand-icon-svg"
      >
        <g
          id="v_hamburger"
          data-name="Group 51"
          transform="translate(-1588 -356)"
        >
          <circle
            id="Ellipse_20"
            data-name="Ellipse 20"
            cx="4"
            cy="4"
            r="4"
            transform="translate(1588 356)"
          />
          <circle
            id="Ellipse_21"
            data-name="Ellipse 21"
            cx="4"
            cy="4"
            r="4"
            transform="translate(1600 356)"
          />
          <circle
            id="Ellipse_22"
            data-name="Ellipse 22"
            cx="4"
            cy="4"
            r="4"
            transform="translate(1612 356)"
          />
        </g>
      </svg>
    </span>
  </div>
</template>

<script>
export default {
  name: "ExpandIcon",
  methods: {},
};
</script>

<style scoped>
.more-container {
  position: relative;
  z-index: 1;
  border-radius: 17px;
  padding: 0 12px;
  line-height: 20px;
  fill: #2e2e2e;
  display: inline-flex;

  height: 20px;
  width: 40px;
  justify-content: center;
  align-items: center;
}
.more-container:hover {
  background-color: rgba(0, 0, 0, 0.2);
  fill: #0f0f0f;
}
.expand-icon {
  height: 25px;
  bottom: 0;
  left: 0;
  width: 100%;
  position: absolute;
  z-index: 2;
  text-align: center;
  fill: #98774f;
  cursor: pointer;
  background-color: rgba(255, 255, 255, 0.7);
}
</style>
